/**
 * @generated SignedSource<<55f9421fa29e274265521769f4ec8b20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplacePersonalizedCarouselLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPersonalizationCarousel_user">;
  readonly " $fragmentType": "PdpRespMarketplacePersonalizedCarouselLazy_user";
};
export type PdpRespMarketplacePersonalizedCarouselLazy_user$key = {
  readonly " $data"?: PdpRespMarketplacePersonalizedCarouselLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplacePersonalizedCarouselLazy_user",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedPersonalizationCarousel_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "19d8baabe22622ccc186b9107353c9ba";

export default node;
